import * as React from 'react'
import { inputVariants, type InputVariantProps } from './Input.variants'
import { cn } from '../../utils/cn'

export type InputProps = InputVariantProps &
  React.InputHTMLAttributes<HTMLInputElement> & {
    label?: string
  }

export default function Input({ variant, label, id, className, ...rest }: InputProps) {
  const inputId = id ?? (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined)

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="text-xs font-medium text-ink-2 tracking-tight">
          {label}
        </label>
      )}
      <input id={inputId} className={cn(inputVariants({ variant }), className)} {...rest} />
    </div>
  )
}
